
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/linear-progress",
      function () {
        return require("private-next-pages/joy-ui/api/linear-progress.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/linear-progress"])
      });
    }
  